'use strict';

var generatedParser = require('./grammar/tabulate.js');

module.exports = generatedParser.parser;


//////////////////
// WEBPACK FOOTER
// ../retabulate-sas-parser/lib/index.js
// module id = 779
// module chunks = 0